import { PreIcon } from '@advanza/ui'
import { useSelector } from 'react-redux'

interface Props {
    serviceId: number
}

interface ServiceStatsState {
    serviceStats: {
        options: {
            competitionStats: Record<number, unknown>
            requestStats: Record<number, unknown>
        }
    }
}

const ServiceStatsExportButton = ({ serviceId }: Props) => {
    const { competitionStats, requestStats } = useSelector(
        (state: ServiceStatsState) => state.serviceStats.options,
    )
    const { protocol, hostname } = window.location
    const url =
        `${protocol}//${hostname}/api/office/services/export-service-stats-csv?encoded=` +
        btoa(
            JSON.stringify({
                competitionOptions: competitionStats[serviceId],
                requestOptions: requestStats[serviceId],
                serviceId,
            }),
        )

    return (
        <>
            <h3 className="text-xl font-semibold text-bodyDark m-0 mb-4 flex items-center gap-2">
                <PreIcon icon="analytics">Service Stats Export</PreIcon>
            </h3>
            <p className="text-[13px] text-grey-800 m-0 mb-4 leading-[1.5]">
                Export competition and request statistics data as CSV for analysis
            </p>
            <a
                href={url}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 px-3 py-1.5 bg-primary-600 text-white text-md font-medium rounded-md no-underline hover:bg-primary-700 hover:text-white transition-colors [&_*]:text-white hover:[&_*]:text-white">
                <PreIcon icon="download" white>
                    Export CSV
                </PreIcon>
            </a>
        </>
    )
}

export default ServiceStatsExportButton
